// What a finished play shares (Sharing): the caption under the sky image and
// the text Copy Text puts on the clipboard. Neither names a word, so nothing
// is spoiled and no hard-tagged word can travel.
import { formatDuration, formatFullDate, playName } from '@wits/core';
import type { PlayStats } from './playStats';

// The image's caption is in the shared core, since the Worker's share page repeats it.
export { captionParts } from '@wits/core';

const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

/** The text Copy Text puts on the clipboard. */
export function shareText(stats: PlayStats, link: string): string {
  const name = playName(stats.mode, stats.variant, stats.layer);
  const outcome =
    stats.mode !== 'apogee'
      ? `${name}: the sky is written`
      : `${name}: ${plural(stats.score ?? 0, 'point', 'points')}`;
  const tally = [plural(stats.constellations, 'constellation', 'constellations'), plural(stats.starsUsed, 'star', 'stars')];
  if (stats.elapsedMs !== null) tally.push(formatDuration(stats.elapsedMs));
  const lines = [`Written in the Stars ✦ ${formatFullDate(stats.date)}`, outcome, tally.join(' · ')];
  // One star per constellation (twelve at most): a small picture of the night.
  if (stats.constellations > 0) lines.push('✦'.repeat(Math.min(stats.constellations, 12)));
  lines.push(link);
  return lines.join('\n');
}
